class Panel {
  /**
   * closePanel: Closes this panel.
   */
  closePanel() {
    this.panelToggle.checked = false;
  }

  setUpPanelEvents() {
    // needed to do this since .bind creates a new reference every time,
    // and we need to remove be able to remove the event listener once it's closed
    const handler = this.handleClickOutsideofElement.bind(this);
    document.removeEventListener('click', handler);

    const applyButton = this.container.querySelector('[data-apply]');
    this.panelToggle = this.container.querySelector('[data-panel-toggle]');

    applyButton?.addEventListener('click', this.closePanel.bind(this));
    document.addEventListener('click', handler);
  }

  /**
   * closes the panel if the click is outside the panel
   */
  handleClickOutsideofElement(event) {
    if (this.container.contains(event.target)) {
      return;
    }

    this.closePanel();
  }

  constructor(configuration) {
    this.container = configuration.container;

    this.container.addEventListener('click', this.setUpPanelEvents.bind(this), {once: true});
  }
}

export default Panel;